<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {ModalAfterAddToCartDto} from "./models/ModalAfterAddToCartDto";
import AddToCartPopinCds from "../../../fmfmo/common/offerdetails/AddToCartPopinCds.vue";

declare const $: any;

export default defineComponent({
    name: "ModalAfterAddToCart",
    components: {
        AddToCartPopinCds
    },
    props: {
        modalId: {
            type: String,
            required: true
        },
        content: {
            type: Object as PropType<ModalAfterAddToCartDto>,
            required: true
        },
        firstIntentionHref: {
            type: String,
            required: true
        },
        secondIntentionHref: {
            type: String,
            required: true
        },
        tmsCategory: {
            type: String,
            required: true
        },
        offerName: {
            type: String,
            default: ''
        },
    },
    computed: {
        selectedOfferInfo() {
            return {
                offerImageUrl: '/images/orange/mobile/sim-card.png',
                offerName: this.offerName,
                offerInCartLabel: this.content.offerAddedLabel,
            }
        },
        visual() {
            return {
                src: this.content.imageUrl,
                smallSrc: this.content.imageUrl,
                alt: this.content.title,
            }
        },
        withDeviceSection() {
            return {
                button: {
                    label: 'Voir tous les téléphones',
                    href: this.firstIntentionHref,
                    tmsDTO: this.tmsFor(
                        'Voir tous les téléphones',
                        this.firstIntentionHref
                    ),
                }
            }
        },
        withoutDeviceSection() {
            return {
                button: {
                    label: this.content.ctaLabel,
                    href: this.secondIntentionHref,
                    tmsDTO: this.tmsFor(this.content.ctaLabel, this.secondIntentionHref),
                }
            }
        },
    },
    methods: {
        tmsFor(label: string, href: string) {
            return {
                tagZone: this.tmsCategory,
                tagName: toBroadbandTmsFormat(label),
                href: toBroadbandTmsFormat(href),
            }
        },
        show(): void {
            $('#' + this.modalId).appendTo("[role='main']").modal("show");
        }
    },
});
</script>

<template>
    <AddToCartPopinCds
        :id="modalId"
        ref="addToCartPopinCds"
        :title="content.title"
        :offer-name="offerName"
        :advantages="[...content.advantages]"
        :selected-offer-info="selectedOfferInfo"
        :visual="visual"
        :with-device-section="withDeviceSection"
        :without-device-section="withoutDeviceSection"
        :is-sub="false"
        :cart-page-url="secondIntentionHref"
    />
</template>
